import { FavoriteMatchButtonComponent } from './favorite-match-button.component'; 

export { FavoriteMatchButtonComponent } from './favorite-match-button.component';